import React, { memo } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from 'react-bootstrap/Button';

const NotFound = ({ reset }) => {
    const navigate = useNavigate();

    return (
        <div className="not-found">
            <span className="dsl-w36 text-400 mb-3 z1">Tune-up underway.</span>
            <span className="dsl-w18 text-200 mb-5 z1">This page will be improved and back on the track soon.</span>
            <Button className="ds-btn go-back" onClick={() => navigate(-1)}>
                GO BACK
            </Button>
            <Button className="ds-btn go-back mt-3" onClick={() => reset()}>
                RESET
            </Button>
        </div>
    );
};

export default memo(NotFound);
